import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { FejlDashboardService } from '../fejl-dashboard.service';
import { FejlDashboardSubSummaryDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/fejl-dashboard-sub-summary-dto';
import { Loader } from 'src/app/services/loader.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'app-fejl-dashboard-knap',
    templateUrl: './fejl-dashboard-knap.component.html',
    styleUrls: ['./fejl-dashboard-knap.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FejlDashboardKnapComponent implements OnInit, OnDestroy {
  @Input() loader: Loader;
  @Output() showlist: EventEmitter<FejlDashboardSubSummaryDto> = new EventEmitter<FejlDashboardSubSummaryDto>();

  isLoading: boolean = false;
  unsubscribe$ = new Subject<void>();

  antalFejl: string = '';

  private _summary: FejlDashboardSubSummaryDto = { antalFejl: 0 };

  @Input() set summary(value: FejlDashboardSubSummaryDto) {
    this._summary = value;

    if (value?.antalFejl == 0) {
      this.antalFejl = 'Alt OK';
      return;
    }
    if (value?.antalFejl) {
      this.antalFejl = value.antalFejl + ' ' + this.service.text(this.summary, this.summary.antalFejl);
    }
  }

  get summary() {
    return this._summary;
  }

  get ikon(): string {
    switch (this.summary?.antalFejl) {
      case 0:
        return 'checkmark-circle';
      default:
        return 'alert-solid';
    }
  }

  get title(): string {
    return this.service.title(this.summary.fejlDashboardType);
  }

  get isactive(): boolean {
    return this.service.active == this.summary.fejlDashboardType;
  }

  setactive() {
    if (this.summary.antalFejl) {
      this.service.active = this.summary.fejlDashboardType;
      this.showlist.emit(this.summary);
    }
  }

  constructor(private service: FejlDashboardService) {}

  ngOnInit(): void {
    this.loader.showStateChanged$.pipe(takeUntil(this.unsubscribe$)).subscribe((show: boolean) => {
      this.isLoading = show;
    });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.unsubscribe();
  }
}
